/* The code is defining two constants `CREATE_ORDER_REQUEST` and `CREATE_ORDER_SUCCESS` using the
`export` keyword. These constants are used to define action types in Redux, a popular JavaScript
library for managing application state. The `CREATE_ORDER_REQUEST` constant represents an action
type for requesting the creation of an order, while the `CREATE_ORDER_SUCCESS` constant represents
an action type for indicating the successful creation of an order. These constants can be imported
and used in other parts of the code to dispatch actions and handle the corresponding state changes. */
export const CREATE_ORDER_REQUEST = 'CREATE_ORDER_REQUEST';
export const CREATE_ORDER_SUCCESS = 'CREATE_ORDER_SUCCESS';
